<form class="flex flex-column" (validate)="save()" novalidate validation-es>
  <label for="comments">{{screen.labels.comments}}</label>

  <div>
    <textarea pInputTextarea name="comments" [(ngModel)]="comments" [rows]="4" [autoResize]="false" class="uppercase"
      validation></textarea>
  </div>

  <hr>

  <div class="align-self-end">
    <button pButton [type]="loading ? 'button' : 'submit'"
      [label]="loading ? screen.actions.saving : screen.actions.save" [icon]="loading ? loadingIcon : 'far fa-save'"
      class="p-button-success p-button-outlined"></button>
  </div>
</form>